var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-btn c-btn--secondary c-btn--primary--large c-btn--h-xlarge",attrs:{"href":_vm.urlToContinueShopping}},[_vm._v("\n  買い物を続ける\n")])}
var staticRenderFns = []

export { render, staticRenderFns }